import React from 'react';
import { useSelector } from 'react-redux';

import { complaintsSelectors } from '../state/selectors';
import Complaint from './ComplaintCard';
import { Box } from '@iclinic/design-system';

const ComplaintsList = () => {
  const ids = [
    ...useSelector(complaintsSelectors.selectIds),
  ].reverse() as string[];

  return (
    <Box mt={ids.length > 0 ? 2 : 0}>
      {ids.map((id) => {
        return (
          <Box key={id} mb={2}>
            <Complaint id={id} />
          </Box>
        );
      })}
    </Box>
  );
};

export default React.memo(ComplaintsList);
